import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useHistory } from 'react-router-dom';
import block from 'bem-cn';

import Button from 'components/Button';
import SVG from 'components/SVG';
// import arrowSVG from '../../img/arrow-desk.svg';
import promotionSVG from '../../img/promotion.svg';


import { getTitlePageFromRoute } from '../../data';

import './Subheader.scss';

const b = block('subheader');
const Subheader = ({ button }) => {
  const locale = useSelector(state => state.locale.locale);
  const { canCreateOnlyPlayer } = useSelector(state => state.auth);
  const location = useLocation();
  // const history = useHistory();

  const getTitle = () => {
    return getTitlePageFromRoute.find(el => location.pathname.includes(el.route));
  };

  const currentItem = getTitle() ?? {};

  const getTitleText = () => {
    const titleKey = currentItem.dynamicTitle ? currentItem.dynamicTitle({ canCreateOnlyPlayer }) : currentItem.title;
    return locale[titleKey];
  };

  if (currentItem?.withoutHeader || currentItem?.withoutHeaderDesktop) return null;
  return (
    <div className={b()}>
      <div className={b('second-title')}>{location.pathname === '/' ? '' : getTitleText()}</div>
      {location.pathname.includes('/users') && (
        <div className={b('buttons')}>
          {!canCreateOnlyPlayer && <Button link="/user/create-agent" text={locale.newAgent} />}
          <Button color="transparent" link="/user/create-player" text={locale.newPlayer} />
        </div>
      )}
      {(location.pathname.includes('/bonus-promo/promotions') ||
        location.pathname.includes('/bonus-promo/promotions/create')) && (
        <div className={b('single-button')}>
          <Button link="/bonus-promo/promotions/create">
            <SVG className={b('single-button-icon')} svgProps={{ svg: promotionSVG }} />
            <span className={b('single-button-text')}>{locale.addPromotion}</span>
          </Button>
        </div>
      )}
    </div>
  );
};

export default Subheader;
